import { isSafari } from 'react-device-detect';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { memo, useState, useEffect } from "react";

// Use a module-level variable to track if the spinner has ever loaded
let hasSpinnerLoadedGlobally = false;

const Spinner = ({ size = 24, type = 'ThreeDots', color = 'var(--app-color-gray-dark)', secondaryColor = 'lightgray', ...rest }) => {
    const [isReady, setIsReady] = useState(hasSpinnerLoadedGlobally);
    const defaultType = type || (isSafari ? 'Watch' : 'Puff');

    useEffect(() => {
        if (!hasSpinnerLoadedGlobally) {
            const timer = setTimeout(() => {
                setIsReady(true);
                hasSpinnerLoadedGlobally = true;
            }, 400);

            return () => clearTimeout(timer);
        }
    }, []);

    return (
        <Loader
            type={defaultType}
            color={isReady ? color : 'transparent'}
            secondaryColor={isReady ? secondaryColor : 'transparent'}
            height={size}
            width={size}
            {...rest}
        />
    );
};

export default memo(Spinner);
